import React from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Paper from "@material-ui/core/Paper";
import constants from "../../constants/tutorialAutomaton";
import { useUser } from "../../context/userContext";
import { useDot } from "../../context/automatonContext";
import DOT from "../../components/MachineElement/DOT";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHistorical";
// import TextField from "@material-ui/core/TextField";
// import connect from "../../assets/img/ConnectState.png";
import "./classes.css";
import { Button, Input } from "@material-ui/core";
import DataService from "services/DataService";
import Loading from "components/Loading/loading";
import simulation from "../../views/Simulate/formatList";
import validations from "../../utils/validationsMachine";
import { useAlert } from "../../context/Feedback/alertContext";
// import { Button } from "@material-ui/core";
// const percent = "100%";

const useStyles = makeStyles(styles);

export default function SimulateWordDialog() {
  const { setAlert } = useAlert();
  const { language, credential } = useUser();
  const {
    isActiveDialogSimulate,
    setActiveDialogSimulate,
    machineStates,
    machineTransitions,
    setResponseSimulate,
    setDataTreeDerivation,
  } = useDot();
  const history = useHistory();
  const [checked, setChecked] = useState(true);
  //   const [spacing] = React.useState(2);
  const [word, setWord] = useState("");
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const handleClose = () => {
    setActiveDialogSimulate(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const toDOTLanguage = () => {
    let dot = new DOT(machineStates, machineTransitions);

    dot.toDotLanguage();

    let string = dot.toString();
    // setDot(string);
    return string;
  };

  const handleSubmitWord = async () => {
    if (word.length > 0) {
      try {
        setLoading(true);
        let dot = toDOTLanguage();
        if (validations.isValidMachine(dot).valid) {
          const response = await DataService.checkWord(dot, word, {
            headers: {
              Authorization: credential,
            },
          });
          const {
            tape,
            wordTape,
            finalStates,
            initialState,
            isAccept,
            symbolsExternFromAlphabet,
          } = response.data;
          setResponseSimulate({
            responseSimulateAutomata: {
              word: wordTape,
              tape: tape,
              finalStates: finalStates,
              initialState,
              isAccept: isAccept,
              symbolsExternFromAlphabet: symbolsExternFromAlphabet,
            },
          });
          const dataTreeDerivation = simulation.formatList(
            tape,
            finalStates,
            initialState
          );

          setDataTreeDerivation(dataTreeDerivation);
          setWord("");
          history.push("/user/responseAutomaton");
        } else {
          setAlert({
            active: true,
            text: constants.alerts.automatonError[language],
            color: "info",
            sevarity: "info",
            // icon: ErrorIcon,
          });
        }
      } catch (e) {
        alert(e);
      }
      setActiveDialogSimulate(false);
      setLoading(false);
    } else {
      setAlert({
        active: true,
        text: constants.alerts.missRegex[language],
        color: "info",
        sevarity: "info",
        // icon: ErrorIcon,
      });
    }
  };

  return (
    <div>
      <Loading loading={loading} />
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveDialogSimulate}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {constants.modal.simulateAutomata[language]}

            <div className="wrapper-button-close button-margin">
              <Button
                style={{
                  backgroundColor: "#999",
                  color: "#FFF",
                  width: "10px",
                }}
                onClick={handleClose}
              >
                X
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Input
            className={classes.input}
            placeholder="Palavra"
            value={word}
            fullWidth
            onChange={(e) => setWord(e.target.value)}
          />
        </DialogContent>
        <DialogActions className={classes.dialog}>
          <Button
            onClick={() => {
              handleSubmitWord();
            }}
          >
            ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
